import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.Yy/yDL',
    defaultMessage: 'Reset password',
  },
});
